<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title">Against the Rules</h1>
<p class="author">Linda Howard</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
<a id="page_4"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?06d36dec